<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'">
  </mat-progress-bar>
}
<!-- Content -->
<div class="flex flex-col flex-auto h-full overflow-hidden bg-card dark:bg-default">

  <!-- Header -->
  <div class="z-10 relative flex flex-row items-center flex-0 w-full border-b bg-gray-100 dark:bg-transparent">

    <!-- Title -->
    <div class="px-6 py-2 text-3xl font-semibold tracking-tight w-1/2">
      @switch (facade) {
        @case ('complex') {
          {{ 'complex' | transloco }}
        }
        @case ('master') {
          {{ 'masterData' | transloco }}
        }
        @case ('form') {
          {{ 'form' | transloco }}
        }
        @case ('tasktype') {
          {{ 'taskTypes' | transloco }}
        }
      }
    </div>

    <!-- Action buttons -->
    <div class="flex flex-col flex-auto items-end justify-center">

    </div>
  </div>

  <!-- Table container -->
    <div class="flex flex-col 2xl:flex-1 2xl:max-h-full flex-0 h-full
        overflow-hidden bg-gray-100 dark:bg-transparent" fuseScrollReset>

    <!-- Table actions -->
    <div class="flex flex-row items-center justify-between py-2 px-4">
      <!-- Search bar -->
      <mat-form-field class="fuse-mat-rounded mr-auto basis-1/3">
        <input type="text" matInput [formControl]="searchControl" [placeholder]="'search' | transloco">
        @if (searchControl.value) {
          <button matSuffix mat-icon-button (click)="clearSearch()">
            <mat-icon svgIcon="mat_outline:close"></mat-icon>
          </button>
        }
        <mat-icon matPrefix svgIcon="mat_outline:search"></mat-icon>
      </mat-form-field>
      <div class="flex">
        <!-- Toggle items -->
        @if (facade !== 'tasktype') {
          <mat-slide-toggle  [(ngModel)]="includeHidden" (change)="hiddenChanged()" class="mr-4">
            {{'includeHidden' | transloco}}
          </mat-slide-toggle>
        }
        <!-- Objectives -->
        @if (facade === 'tasktype' && showGoalsUpload) {
          <button class="mr-8" mat-raised-button color="accent" [matMenuTriggerFor]="menuExcel">
            <mat-icon class="text-on-accent" [svgIcon]="'mat_solid:expand_more'"></mat-icon>
            <span class="ml-2 mr-1">{{ 'uploadGoalMenu' | transloco}}</span>
          </button>
        }
        <mat-menu #menuExcel="matMenu">
          <button mat-menu-item (click)="downloadGoalModel()">
            <mat-icon [svgIcon]="'mat_outline:download'" class="icon-size-5 mr2"></mat-icon>
            <span>{{ 'downloadGoalModel' | transloco}}</span>
          </button>
          <button mat-menu-item (click)="openUploadDialog()">
            <mat-icon [svgIcon]="'mat_outline:upload'" class="icon-size-5 mr2"></mat-icon>
            <span>{{ 'uploadGoalModel' | transloco}}</span>
          </button>
        </mat-menu>
        <!-- Add item -->
        @if (hasPermissionToDesignRepository()) {
<a mat-flat-button color="primary" [routerLink]="'new'" [queryParams]="{
                    marca_code: params.marca_code,
                    cliente_code: params.cliente_code,
                    projectId: params.projectId,
                    serviceId: params.serviceId,
                    locator
                }">
            <mat-icon class="text-on-primary" svgIcon="mat_outline:add"></mat-icon>
            {{ getAddCaption() }}
          </a>
        }
      </div>
    </div>

    <!-- Table -->
    <div class="flex flex-col mb-10 pb-6 overflow-y-auto">

      <!-- Header -->
            <div class="flex flex-row gap-4 sticky top-0 px-6 py-4 text-md font-semibold text-secondary
                shadow bg-gray-50 dark:bg-slate-900 md:px-8" matSort matSortDisableClear>
        <div class="flex-auto w-64" mat-sort-header="name">
          {{ 'name' | transloco }}
        </div>
        <div class="flex-auto w-64" mat-sort-header="belongsTo">
          {{ 'belongsTo' | transloco }}
        </div>
        <div class="flex-auto w-32">
          {{ 'typology' | transloco }}
        </div>
        @if (facade !== 'tasktype') {
          <div class="flex-auto w-32 flex content-start" mat-sort-header="status">
            {{ 'status' | transloco }}
          </div>
        }
        <div class="flex-auto w-32  flex justify-center">
          {{ 'actions' | transloco }}
        </div>
      </div>

      @if (filteredRepoList.length > 0) {
        <!-- Rows (iterator) -->
        @for (repo of viewList; track repo) {
                    <div class="flex flex-row gap-4 items-center px-6 py-3
                        border-b md:px-8">
            <div class="flex flex-row flex-auto w-64 items-center">
              {{ facade !== 'tasktype' ? (repo.caption | localize) : repo.name }}
            </div>
            <div class="flex-auto w-64">
              <a (click)="navigateToBelongsTo(repo)"
                [ngClass]="{ 'text-primary-500 cursor-pointer': !repo.sameLocator }">
                {{ repo.belongsToCaption }}
              </a>
            </div>
            <div class="flex-auto w-32">
              {{ getTypology(repo.typology) | localize }}
            </div>
            @if (facade !== 'tasktype') {
              <div class="flex-auto w-32 flex content-start items-center">
                <!--{{ repo.status | transloco }}-->
                @if (facade === 'master' || facade === 'form') {
                  <!-- Design View -->
                  @if (repo?.status === 'DESIGN') {
                    <mat-icon [svgIcon]="'mat_outline:draw'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.designList' | transloco}}"></mat-icon>
                  }
                  <!-- Live View -->
                  @if (repo?.status === 'LIVE') {
                    <mat-icon [svgIcon]="'feather:heart'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.liveList' | transloco}}"></mat-icon>
                  }
                  <!-- Static View -->
                  @if (repo?.status === 'STATIC') {
                    <mat-icon [svgIcon]="'feather:anchor'" [ngStyle]="{'color':'black'}" matTooltip="{{'repositoryIcons.static' | transloco}}"></mat-icon>
                  }
                  @if (repo?.status !== 'STATIC') {
                    <!-- Locked -->
                    @if (repo?.locked) {
                      <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-closed'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.locked' | transloco}}"></mat-icon>
                    }
                    <!-- Unlocked -->
                    @if (!repo?.locked) {
                      <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-open'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.unlocked' | transloco}}"></mat-icon>
                    }
                    <!-- Evened -->
                    @if (repo?.evened) {
                      <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-online'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.evened' | transloco}}"></mat-icon>
                    }
                    <!-- Unevened -->
                    @if (!repo?.evened) {
                      <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-offline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.unevened' | transloco}}"></mat-icon>
                    }
                    <!-- Has Request -->
                    @if (repo?.dtypeToGoLiveRequest && !repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
                      <mat-icon class="ml-2" [svgIcon]="'mat_outline:note_add'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasRequest' | transloco}}"></mat-icon>
                    }
                    <!-- Has Schedule -->
                    @if (repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
                      <mat-icon class="ml-2" [svgIcon]="'feather:clock'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasSchedule' | transloco}}"></mat-icon>
                    }
                    <!-- Migrating -->
                    @if (repo?.migrating) {
                      <mat-icon class="ml-2" [svgIcon]="'mat_outline:sync_problem'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.migrating' | transloco}}"></mat-icon>
                    }
                    <!-- Error Status -->
                    @if (repo?.errorStatus === 'ERROR') {
                      <mat-icon class="ml-2" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.errors' | transloco}}"></mat-icon>
                    }
                  }
                }
              </div>
            }
            <div class="flex-auto w-32 flex justify-center items-center">
              @if (facade !== 'tasktype' && facade !== 'masterSystem' && ((repo.sameLocator && hasPermissionToDesignRepository()) || repo.status !== 'DESIGN')) {
                <a
                  [routerLink]="repo.status === 'DESIGN' ? 'design' : facade === 'master' && role?.masterDataManagement ? 'data' : 'summary'"
                                [queryParams]="{
                                    ou: params.ou,
                                    marca_code: params.marca_code,
                                    cliente_code: params.cliente_code,
                                    projectId: params.projectId,
                                    serviceId: params.serviceId,
                                    uri: repo.uri,
                                    locator
                                }" class="text-primary-500">
                  {{ (repo.status === 'DESIGN' ? 'modify' : 'goTo') | transloco }}
                </a>
              }
              @if (facade === 'tasktype' && repo.sameLocator && hasPermissionToDesignRepository()) {
                <a [routerLink]="repo.taskTypeId"
                                [queryParams]="{
                                    ou: params.ou,
                                    marca_code: params.marca_code,
                                    cliente_code: params.cliente_code,
                                    projectId: params.projectId,
                                    serviceId: params.serviceId,
                                    uri: repo.uri,
                                    locator
                                }" class="text-primary-500">
                  {{ 'modify' | transloco }}
                </a>
              }
              @if (facade === 'masterSystem' && (repo.sameLocator || repo.status !== 'DESIGN')) {
                <a
                  [routerLink]="'data'"
                                [queryParams]="{
                                    ou: params.ou,
                                    marca_code: params.marca_code,
                                    cliente_code: params.cliente_code,
                                    projectId: params.projectId,
                                    serviceId: params.serviceId,
                                    uri: repo.uri,
                                    locator
                                }" class="text-primary-500">
                  {{ 'goTo' | transloco }}
                </a>
              }
              @if (repo.sameLocator && hasPermissionToDesignRepository() && repo.status !== 'STATIC') {
                <button class="ml-2"
                  mat-icon-button
                  matTooltip="{{'remove' | transloco}}"
                  (click)="deleteRepository(repo)">
                  <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
              }
            </div>
          </div>
        }
      } @else {
        <div class="flex justify-center font-semibold px-6 py-8 md:px-8">
          @switch (facade) {
            @case ('complex') {
              {{ (searchControl.value ? 'noFilteredRepos' : 'noRepos') | transloco: { facade: ('complex' | transloco).toLowerCase(), location: captionLocator } }}
            }
            @case ('master') {
              {{ (searchControl.value ? 'noFilteredRepos' : 'noRepos') | transloco: { facade: ('masterData' | transloco).toLowerCase(), location: captionLocator } }}
            }
            @case ('form') {
              {{ (searchControl.value ? 'noFilteredRepos' : 'noRepos') | transloco: { facade: ('form' | transloco).toLowerCase(), location: captionLocator } }}
            }
            @case ('tasktype') {
              {{ (searchControl.value ? 'noFilteredRepos' : 'noRepos') | transloco: { facade: ('taskTypes' | transloco).toLowerCase(), location: captionLocator } }}
            }
          }
        </div>
      }
      <mat-paginator #paginator
        class="sm:absolute sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-slate-900"
        [ngClass]="{'pointer-events-none': loading}" [length]="$safeNavigationMigration(pagination?.length)"
        [pageIndex]="$safeNavigationMigration(pagination?.page)" [pageSize]="$safeNavigationMigration(pagination?.size)" [pageSizeOptions]="[5, 10, 15]"
      [showFirstLastButtons]="true"></mat-paginator>
    </div>
  </div>
</div>

